import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { TimeEntryService } from 'src/api/v2';

import { EVENT_TIME_ENTRIES_KEY } from 'src/constants/hook-keys';
import { useAuth } from 'src/features/authorization';
import { useCluster } from 'src/features/cluster';

export type UseEventTimeEntriesProps = {
  eventId?: string;
};

export default function useEventTimeEntries(eventId: string) {
  const { cluster } = useCluster();

  const [service] = useState(new TimeEntryService());

  const { checkAccess } = useAuth();
  const { read } = checkAccess('Inkind');

  const { data, ...rest } = useQuery({
    queryKey: [EVENT_TIME_ENTRIES_KEY, eventId],
    queryFn: () => service.getTimeEntries(cluster!.id, null, eventId, null, null, null, null, null),
    enabled: !!cluster && !!eventId && read,
  });

  return {
    timeEntries: data || [],
    ...rest,
  };
}
